import React from 'react';

const ResponsesTable = ({ responses }) => {
  if (responses.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No responses for this campaign yet
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200 rounded-lg">
        <thead className="bg-gray-50">
        <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Response</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Response Data</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Responded At</th>
        </tr>
      </thead>
        <tbody className="bg-white divide-y divide-gray-200">
        {responses.map((response, index) => {
          const date = new Date(response.responded_at);
          const formattedDate = date.toLocaleString();
            const isYes = response.response === 'yes';

          return (
              <tr key={response.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{index + 1}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{response.email_id}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    isYes 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'
                  }`}>
                  {response.response.toUpperCase()}
                </span>
              </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{response.response_data || '-'}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formattedDate}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
  );
};

export default ResponsesTable;
